import React from 'react';
import { Card, Descriptions, Button, Typography } from 'antd';
import { UserAddOutlined, CheckOutlined, LinkOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import createPatient from '../../utils/patient/createPatient';
import updateSession from '../../utils/session/updateSession';
import updateCall from '../../utils/call/updateCall';
import { toast } from 'react-hot-toast';
import { logEvent } from '../../analytics';

const { Paragraph } = Typography;


const NoteAddPatient = ({ patientUpdates, fields, source, onLinkPatient, onPatientCreated }) => {
  const { t } = useTranslation();

  const handleAddNew = async () => {
    try {
      if (!patientUpdates) {
        console.error('No patient updates to save');
        return;
      }
      logEvent('NotePatientWidget', 'CreateNewPatient');
      // Transform the updates to only include the values
      const attributes = Object.entries(patientUpdates).reduce((acc, [key, { value }]) => {
        acc[key] = value;
        return acc;
      }, {});
      console.log(`NoteAddPatient attributes: ${attributes}, source is Session?: ${source.isSession()}`);
      const patient = await createPatient(attributes);
      if (source.isSession()) {
        await updateSession(source.getUUID(), { patient_uuid: patient.getUUID() });
      } else {
        await updateCall(source.getUUID(), { patient_uuid: patient.getUUID() });
      }
      toast.success(t('patient_form.created'));
      onPatientCreated?.(patient.getUUID());
    } catch (error) {
      toast.error(t('patient_form.errors.save_failed'));
    }
  };

  console.log('NoteAddPatient received patientUpdates:', patientUpdates);

  const renderPatientUpdates = () => {
    console.log('renderPatientUpdates called with patientUpdates:', patientUpdates);
    
    if (!patientUpdates) {
      console.log('No patientUpdates, returning null');
      return null;
    }

    console.log('Fields that have values in patientUpdates:', 
      fields.filter(field => patientUpdates[field.key])
    );

    const renderedFields = fields.map(({ key, label }) => {
      const hasValue = Boolean(patientUpdates[key]);
      console.log(`Field ${key}:`, { 
        label, 
        value: patientUpdates[key],
        willRender: hasValue 
      });
      return hasValue && (
        <Descriptions.Item key={key} label={label}>
          <span style={{
            backgroundColor: '#f6ffed',
            padding: '0 4px',
            borderRadius: '2px',
            display: 'inline-flex',
            alignItems: 'center',
            lineHeight: '22px'
          }}>
            {patientUpdates[key].value}
          </span>
        </Descriptions.Item>
      );
    }).filter(Boolean);

    console.log('Number of fields that will be rendered:', renderedFields.length);

    return (
      <Descriptions column={1} size="small">
        {renderedFields}
      </Descriptions>
    );
  };

  const cardTitle = (
    <>
      <UserAddOutlined style={{ marginRight: 8 }} />
      {t('session_details_patient.add_patient_title')}
    </>
  );

  return (
    <Card
      title={cardTitle}
      style={{ marginBottom: 24 }}
    >
      {renderPatientUpdates()}
      <div style={{ marginTop: '20px' }}>
        <Button
          type="primary"
          onClick={handleAddNew}
          icon={<CheckOutlined />}
          data-testid="add-patient-button"
          style={{ width: '230px' }}
        >
          {t('session_details_patient.add_new')}
        </Button>
        <div style={{ marginTop: '16px' }}>
          <Button
            onClick={() => {
              logEvent('NotePatientWidget', 'LinkExistingPatient');
              onLinkPatient();
            }}
            icon={<LinkOutlined />}
            data-testid="link-existing-button"
            style={{ width: '230px' }}
          >
            {t('session_details_patient.link_existing')}
          </Button>
        </div>
        <div style={{ marginTop: '25px', marginBottom: '-10px' }}>
          <Paragraph type="secondary" style={{ fontStyle: 'italic' }}>
            {t('session_details_patient.add_patient_nudge')}
          </Paragraph>
        </div>
      </div>
    </Card>
  );
};

export default NoteAddPatient; 